var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left rounded-xl ma-10 pa-10",staticStyle:{"background-color":"white"},domProps:{"innerHTML":_vm._s(_vm.$t('eula'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }